var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.561,
    height: 26.785,
    viewBox: "0 0 29.561 26.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video-icon",
    d: "M5.675,0H23.886a5.7,5.7,0,0,1,5.675,5.675V21.11a5.668,5.668,0,0,1-1.655,4.008l-.053.048A5.661,5.661,0,0,1,23.9,26.785H5.675a5.661,5.661,0,0,1-4.008-1.667l-.048-.053A5.644,5.644,0,0,1,0,21.11V5.675A5.692,5.692,0,0,1,5.675,0Zm7.316,11.482,6.074,4.241a.912.912,0,0,1,.034,1.516l-6.055,4.184a.9.9,0,0,1-.577.209.912.912,0,0,1-.919-.912V12.226h0a.907.907,0,0,1,1.443-.743ZM1.768,6.368H5.136l2.18-4.6H5.675A3.919,3.919,0,0,0,1.768,5.675v.693Zm7.145-4.6-2.177,4.6h6.1l2.182-4.592h0Zm7.7,0-2.2,4.6h5.942l2.184-4.6Zm7.535,0-2.192,4.6h5.839V5.675a3.926,3.926,0,0,0-3.657-3.9ZM27.8,8.187H1.768V21.11a3.9,3.9,0,0,0,1.119,2.718l.041.038a3.9,3.9,0,0,0,2.747,1.152H23.886A3.9,3.9,0,0,0,26.6,23.913l.038-.043a3.89,3.89,0,0,0,1.15-2.757V8.194Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/Videos.4ec53fff25b588a3637398d7d6810bc9.svg";
export { ForwardRef as ReactComponent };